module.exports = __webpack_public_path__ + "fonts/gothic-a1-v8-latin-800.c3df87e7.woff2";